

export interface SimpleRect {
  top: number;
  left: number;
  width?: number;
  height?: number;
  bottom?: number;
}

export function isTargetWindow(target: Element | Window): target is Window {
  return typeof window !== 'undefined' && target === window;
}

export function getTargetRect(target: Element | Window): SimpleRect {
  return !isTargetWindow(target)
    ? target.getBoundingClientRect()
    : {
        top: 0,
        left: 0,
        bottom: 0
      };
}
